import React from 'react';
import CategoryIndex from './Category';

const Category = () => <CategoryIndex />;

export default Category;
